module.exports = __webpack_public_path__ + "static/4-small-8f54826fd24895bc58a40b24da75e872.jpg";